import React from 'react';

import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {RecentFormWidgetFullPlaceholder} from "./recent-form-widget.full.placeholder";
import {RecentFormWidgetPartialPlaceholder} from "./recent-form-widget.partial.placeholder";
import {WithDevice} from "../../../../core/components/composers/with-device";

export class RecentFormWidgetPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
  isFullView: Boolean;
}

export const RecentFormWidgetPlaceholder = WithDevice((props: RecentFormWidgetPlaceholderProps) => {
  return props.isFullView ? <RecentFormWidgetFullPlaceholder {...props}/> : <RecentFormWidgetPartialPlaceholder {...props}/>
});
